export class Dokument {
    fileName: string;
    size: number;
    downloading: boolean;
}
